import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { cn } from '../../lib/utils';

// Muted looping video that only plays while on screen, and stays paused for
// users who prefer reduced motion.
export default function MotionVideo({ src, poster, title, className }) {
  const videoRef = useRef(null);
  const { ref, inView } = useInView({ threshold: 0.25 });

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (inView && !reduceMotion) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [inView]);

  return (
    <div ref={ref} className={cn('overflow-hidden bg-black', className)}>
      <video
        ref={videoRef}
        src={src}
        poster={poster || undefined}
        muted
        loop
        playsInline
        preload="metadata"
        aria-label={title}
        className="w-full h-full object-cover"
      />
    </div>
  );
}
